import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Alert,
} from "reactstrap";
import Header from "components/Headers/Header";

const ConsultaAbastecimiento = () => {
  const [idCaso, setIdCaso] = useState("");
  const [casoEncontrado, setCasoEncontrado] = useState(null);
  const [error, setError] = useState("");
  const [htmlContent, setHtmlContent] = useState("");

  const buscarCaso = async () => {
    try {
      setError("");
      setCasoEncontrado(null);
      setHtmlContent("");

      const response = await axios.get(
        "https://contratosback.azurewebsites.net/api/v1/ObtenerCasosAsignados/1",
      );

      const casos = response.data;
      const encontrado = casos.find((caso) => caso.id === parseInt(idCaso));

      if (encontrado) {
        setCasoEncontrado(encontrado);
        // Obtener el documento asociado automáticamente
        fetchHtmlContent(encontrado.id);
      } else {
        setError("No se encontró un caso con ese ID.");
      }
    } catch (err) {
      console.error(err);
      setError("Error al consultar los casos.");
    }
  };

  const fetchHtmlContent = async (id) => {
    try {
      const response = await axios.get(
        `https://contratosback.azurewebsites.net/api/v1/ObtenerContrato/${id}`,
      );
      setHtmlContent(response.data);
    } catch (error) {
      console.error("Error fetching HTML content", error);
      setHtmlContent("<p style='color:red;'>Error al cargar el documento.</p>");
    }
  };

  return (
    <>
      <Header />
      <Container className="mt-4">
        <Row className="mb-3">
          <Col md="6">
            <Input
              type="number"
              placeholder="Digite el número del caso"
              value={idCaso}
              onChange={(e) => setIdCaso(e.target.value)}
            />
          </Col>
          <Col md="3">
            <Button color="primary" onClick={buscarCaso}>
              Buscar
            </Button>
          </Col>
        </Row>

        {error && <Alert color="danger">{error}</Alert>}

        {casoEncontrado && (
          <Card className="mb-4">
            <CardBody>
              <CardTitle tag="h5">
                Caso #{casoEncontrado.id} - {casoEncontrado.tipoContrato}
              </CardTitle>
              <CardText>
                <strong>Proveedor:</strong> {casoEncontrado.nombreProveedor}
              </CardText>
              <CardText>
                <strong>NIT:</strong> {casoEncontrado.nit}
              </CardText>
              <CardText>
                <strong>Dirección:</strong> {casoEncontrado.direccion}
              </CardText>
              <CardText>
                <strong>Ciudad:</strong> {casoEncontrado.ciudad}
              </CardText>
              <CardText>
                <strong>Teléfono:</strong> {casoEncontrado.telefono}
              </CardText>
              <CardText>
                <strong>Fecha:</strong>{" "}
                {new Date(casoEncontrado.fecha).toLocaleDateString()}
              </CardText>
              <CardText>
                <strong>Estado:</strong> {casoEncontrado.descripcion}
              </CardText>
            </CardBody>
          </Card>
        )}

        {htmlContent && (
          <Card>
            <CardBody>
              <h5>Documento</h5>
              <div
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  maxHeight: "600px",
                  overflowY: "auto",
                }}
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            </CardBody>
          </Card>
        )}
      </Container>
    </>
  );
};

export default ConsultaAbastecimiento;
